import { render, staticRenderFns } from "./FuseSearchItem.vue?vue&type=template&id=70b179e6&"
import script from "./FuseSearchItem.vue?vue&type=script&lang=js&"
export * from "./FuseSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./FuseSearchItem.vue?vue&type=style&index=0&id=70b179e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports